if (!customElements.get('size-guide-modal')) {
  customElements.define(
    'size-guide-modal',
    class SizeGuideModal extends DrawerComponent {
      constructor() {
        super();
      }

      prepareToShow() {
        super.prepareToShow();
        document.dispatchEvent(new CustomEvent('size-guide:open'));
      }

      handleAfterHide() {
        super.handleAfterHide();
        document.dispatchEvent(new CustomEvent('size-guide:close'));
      }
    }
  );
}

// Size guide button handler
class SizeGuideButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.modalId = this.dataset.modalId || 'SizeGuideModal';
    
    if (this.button) {
      this.button.addEventListener('click', this.openSizeGuide.bind(this));
    }
  }

  openSizeGuide(e) {
    e.preventDefault();
    const modal = document.getElementById(this.modalId);
    if (modal) {
      modal.show();
    }
  }
}

customElements.define('size-guide-button', SizeGuideButton);

// Only advertise the horizontal swipe on tables that actually overflow, and
// drop the hint once the reader has reached the last column.
function updateSizeGuideTableHints(root) {
  (root || document).querySelectorAll('.size-guide__table-scroll').forEach((scroller) => {
    const overflow = scroller.scrollWidth - scroller.clientWidth;
    const scrollable = overflow > 1;

    scroller.classList.toggle('is-not-scrollable', !scrollable);
    scroller.classList.toggle('is-scrolled-end', scrollable && scroller.scrollLeft >= overflow - 1);

    if (scrollable && !scroller.dataset.hintBound) {
      scroller.dataset.hintBound = 'true';
      // keyboard users need to be able to scroll the region too
      scroller.setAttribute('tabindex', '0');
      scroller.addEventListener('scroll', () => updateSizeGuideTableHints(scroller.parentElement), {
        passive: true,
      });
    }
  });
}

document.addEventListener('size-guide:open', () => {
  requestAnimationFrame(() => updateSizeGuideTableHints());
});

window.addEventListener('resize', () => updateSizeGuideTableHints(), { passive: true });
